/* eslint-disable no-underscore-dangle */
import utils from 'utils/utils';
import Model from 'utils/model';
import config from 'player/config';
import Asset from './asset';
import NextAsset from './next-asset';

/**
 * Parse thata
 *
 * @param response
 * @param vendor
 * @returns {Array}
 */
function onResponseSuccess(vendor, response) {
    const data = JSON.parse(response.responseText);
    const result = [];


    if (data._embedded && data._embedded.assets) {
        utils.each(data._embedded.assets, item => {
            result.push(new Asset(utils.extend(item, {
                vendor: vendor
            })));
        });
    }

    return result;
}

/**
     * Could not fetch any data
     *
     * @returns {string}
     */
function onResponseError() {
    return 'noAssetsFound';
}

function fetch(vendor, url) {
    return new Promise((resolve, reject) => {
        utils.ajax(url, resolve, reject, true);
    }).then(onResponseSuccess.bind(this, vendor), onResponseError);
}

function fetchRecommendedItems(vendor, url) {
    return fetch(vendor, url).then(data => {
        if (utils.isArray(data) && data.length === 0) {
            // fetch with old related
            return fetch(vendor, url.replace('related-ml', 'related'));
        }

        return data;
    });
}

function fetchItemsByIds(vendor, assetsIds) {
    const url = config.api.getUrl(vendor, `/assets?&filter=assetId::${assetsIds.join(',')}&limit=${assetsIds.length}`);
    return fetch(vendor, url);
}

const Recommended = function (options) {
    this.useMlEngine = options && options.ml;

    this.asset = options.asset;
    this.nextAsset = new NextAsset({
        asset: this.asset
    });
};

Recommended.prototype = {
    url: function () {
        const relatedEndpoint = (this.useMlEngine) ? 'related-ml?limit=20' : 'related';

        return config.api.getUrl(
            this.asset.getVendor(),
            `/assets/${this.asset.get('id')}/${relatedEndpoint}`
        );
    },

    /**
         * Fetch next asset
         *
         * @returns {Promise}
         */
    getNextAsset: function(options) {
        const nextAsset = this.asset;

        if (options && options.asset) {
            return this.nextAsset.fetchNextAssetById(
                // set vendor is specified or use main asset as default
                options.asset.vendor || this.asset.getVendor(),
                // asset can be object or number with asset id
                options.asset.id || options.asset
            );
        }

        return this.nextAsset.fetch(nextAsset, utils.extend({
            useMlEngine: this.useMlEngine
        }, options));
    },

    /**
         * Fetch recommended asset list
         * Fetch assets by ids when items provided as a param
         *
         * @param items optional array of ids
         * @returns {*}
         */
    getItems: function (items) {
        if (!utils.isArray(items) || items.length === 0) {
            return fetchRecommendedItems(this.asset.getVendor(), this.url());
        }

        return fetchItemsByIds(this.asset.getVendor(), items);
    }
};

utils.extend(Recommended.prototype, Model);

export default Recommended;
